/* global google */
if (typeof module === 'object')
  module.exports = GoogleMap;

function GoogleMap (options) {

  'use strict';

  var self = this;
  var map = {
    options: options || {}
  };
/*
  if (window.console) {
    console.log('Map variable:');
    console.log(map);
  }
*/

  this._labels = {};

  this.get = function (prop) {
    return map[prop];
  };

  this.getMap = function() {
    return map.instance;
  };

  this.set = function (prop, value) {
    map[prop] = value;
    return map[prop];
  };

  this.loadMapApi = function (initFunc) {
    if (!$.isFunction(window[initFunc])) {
      if(window.console)
        console.log('init func does not exist');

      return false;
    }
    if (!map.mapLoaded && !window.google) {

      const apiKey = location.hostname.endsWith('sa.cz')
        ? 'AIzaSyBAecy3KoxWFoeQ1O-ly7lGOLmhTvgKgtk' //development
        : 'AIzaSyA1m3Jdmajrb-UOmUoqMoClMVEJYUOsPRQ'; //production

      var script = document.createElement('script');
      script.id = 'route-map';
      script.type = 'text/javascript';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=${initFunc}`;
      document.body.appendChild(script);
      map.mapLoaded = true;
    } else {
      window[initFunc]();
    }
  };

  this.drawPolyline = function (coords, eventHandlers) {
    var options = $.extend(map.options.polyline, {
        path: coords,
        map: map.instance
      }),
      polyline = new google.maps.Polyline(options);
    registerEventHandlers(polyline, eventHandlers);
    //console.log(polyline.options());
    return polyline;
  };

  this.drawMarker = function (markerData, eventHandlers) {
    var icon = markerData.icon || map.options.marker.icon,
      options = $.extend(markerData, {
        icon: icon ? handleIcon(icon) : null,
        position: new google.maps.LatLng(markerData.x, markerData.y)
      }),
      marker = new google.maps.Marker(options);
    registerEventHandlers(marker, eventHandlers);

    return marker;

    function handleIcon (icon) {
      if (typeof icon === 'string') return new google.maps.MarkerImage(icon, new google.maps.Size(250.34375, 414.15625), null, null, new google.maps.Size(17, 28));
      icon.anchor = icon.anchor ? new google.maps.Point(icon.anchor.x, icon.anchor.y) : null;
      return icon;
    }
  };

  function registerEventHandlers (item, handlers) {
    for (var event in handlers) {
      if ($.isFunction(handlers[event])) google.maps.event.addListener(item, event, handlers[event]);
    }
  }

  this.drawMarkers = function (items, eventHandlers) {
    var markers = [];
    items.forEach(function (item) {
      markers.push(self.drawMarker(item, eventHandlers));
    });
    return markers;
  };

  this.drawLabel = function (marker, eventHandlers) {
    if (!marker.x || !marker.y)
      return false;
    var options = $.extend({}, marker);
    var label = new Label(options, eventHandlers);

    self._labels[marker.id] = label;

    return label;
  };

  this.removeLabel = function (id) {
    if (!self._labels[id])
      return false;
    if ($.isFunction(self._labels[id].onRemove))
      self._labels[id].onRemove();
  };

  this.drawLabels = function (items, eventHandlers) {
    var labels = [];
    items.forEach(function (item) {
      var label = self.drawLabel(item, eventHandlers);
      if (label) labels.push(label);
    });
    return labels;
  };

  this.removeInstance = function (instance) {
    if (!instance) return false;
    google.maps.event.clearInstanceListeners(instance);
    instance.setMap(null);
    if ($.isFunction(instance.onRemove))
      instance.onRemove();
  };

  this.removeInstances = function (instances) {
    instances.forEach(self.removeInstance);
    instances.length = 0;
    return instances;
  };

  this.setLabelPrototype = function () {
    Label.prototype = new google.maps.OverlayView();

    Label.prototype.onAdd = function () {
      this.getPanes().overlayImage.appendChild(this.div_);
      this.div_.style.marginLeft = -(this.div_.offsetWidth / 2);
    };

    Label.prototype.onRemove = function () {
      this.setMap(null);
      if (this.div_.parentNode)
        this.div_.parentNode.removeChild(this.div_);
      for (var event in this._eventHandlers) {
        if ($.isFunction(this._eventHandlers[event])) google.maps.event.removeListener(this._eventHandlers[event]);
      }
    };

    Label.prototype.draw = function () {
      var position = this.getProjection().fromLatLngToDivPixel(this.get('position'));
      this.div_.style.left = position.x + 'px';
      this.div_.style.top = position.y + 'px';
    };

  };

  this.getMapStyles = function (features, disabled) {
    var styles = [];
    Object.keys(features).forEach(function (key) {
      styles.push({
        featureType: key,
        stylers: features[key]
      });
    });
    disabled.forEach(function (key) {
      styles.push({
        featureType: key,
        stylers: [{visibility: 'off'}]
      });
    });
    return styles;
  };

  function Label(options, eventHandlers) {
    var div = this.div_ = document.createElement('div');
    this.setValues(options);
    this.setMap(map.instance);
    this._eventHandlers = {};
    for (var event in eventHandlers) {
      if ($.isFunction(eventHandlers[event])) this._eventHandlers[event] = google.maps.event.addDomListener(this.div_, event, eventHandlers[event].bind(this));
    }
    div.style.cssText = 'position: absolute;';
    div.className = 'map-label';
    div.appendChild(document.createTextNode(this.get('name')));

  }

}
